import Vue from 'vue'
import VueRouter from 'vue-router'
import ConfigParams from '../views/ConfigParams.vue'
import HomePage from '../views/HomePage.vue'
import LogIn from '../views/LogIn.vue'
import ApiDocs from '../views/ApiDocs.vue'
import ConfManage from '../views/ConfManage.vue'
import CreateConfig from '../actions/CreateConfig.vue'
import DeleteConfig from '../actions/DeleteConfig.vue'
import DeleteConfigFile from '../actions/DeleteConfigFile.vue'
import DownloadConfig from '../actions/DownloadConfig.vue'
import ShareConfig from '../actions/ShareConfig.vue'
import UploadConfig from '../actions/UploadConfig.vue'
import TuningGuide from '../views/TuningGuide.vue'
import ConfigurationSnippet from '../views/ConfigurationSnippet.vue'
import NotFound from '../components/NotFound.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/login',
    name: 'LogIn',
    component: LogIn
  },
  {
    path: '/manage/config/:id',
    name: 'ConfigParams',
    component: ConfigParams
  },
  {
    path: '/manage/config/public/:id',
    name: 'PublicConfigParams',
    component: ConfigParams
  },
  {
    path: '/manage/config/tuning/:id',
    name: 'TuningGuide',
    component: TuningGuide
  },
  {
    path: '/tuning-guide',
    name: 'PublicTuningGuide',
    component: TuningGuide
  },
  {
    path: '/manage/config/action/validate',
    name: 'ValidateConfig',
    component: ConfigParams
  },
  {
    path: '/manage/config/action/create',
    name: 'CreateConfig',
    component: CreateConfig
  },
  {
    path: '/manage/config/action/edit/:id',
    name: 'CreateConfig',
    component: CreateConfig
  },
  {
    path: '/manage/config/action/delete/:id',
    name: 'DeleteConfig',
    component: DeleteConfig
  },
  {
    path: '/manage/config/action/delete/file/:id',
    name: 'DeleteConfigFile',
    component: DeleteConfigFile
  },
  {
    path: '/manage/config/action/download/:id',
    name: 'DownloadConfig',
    component: DownloadConfig
  },
  {
    path: '/manage/config/action/download/public/:id',
    name: 'DownloadPublicConfig',
    component: DownloadConfig
  },
  {
    path: '/manage/config/action/share/:id',
    name: 'ShareConfig',
    component: ShareConfig
  },
  {
    path: '/manage/config/action/upload/:id',
    name: 'UploadConfig',
    component: UploadConfig
  },
  {
    path: '/manage',
    name: 'ConfManage',
    component: ConfManage
  },
  {
    path: '/manage/apidocs',
    name: 'ApiDocs',
    component: ApiDocs
  },
  {
    path: '/manage/snippet-usage',
    name: 'ConfigurationSnippet',
    component: ConfigurationSnippet
  },
  {
    path: '*',
    component: NotFound,
    name: 'NotFound'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
